var map = {
	"./_template.jsx": 387,
	"./docs/ArrayUtils.json": 1080,
	"./docs/AuthenticatedProxy.json": 1081,
	"./docs/BasicToken.json": 1082,
	"./docs/BurnableToken.json": 1083,
	"./docs/DelayedReleaseToken.json": 1084,
	"./docs/DelegateProxy.json": 1085,
	"./docs/DelegatedShareholderAssociation.json": 1086,
	"./docs/Exchange.json": 1087,
	"./docs/ExchangeCore.json": 1088,
	"./docs/MerkleProof.json": 1089,
	"./docs/Migrations.json": 1090,
	"./docs/Ownable.json": 1091,
	"./docs/ProxyRegistry.json": 1092,
	"./docs/ReentrancyGuarded.json": 1093,
	"./docs/SafeMath.json": 1094,
	"./docs/SaleKindInterface.json": 1095,
	"./docs/StandardToken.json": 1096,
	"./docs/TestDAO.json": 1097,
	"./docs/TestStatic.json": 1098,
	"./docs/TestToken.json": 1099,
	"./docs/TokenLocker.json": 1100,
	"./docs/TokenRecipient.json": 1101,
	"./docs/TokenTransferProxy.json": 1102,
	"./docs/UTXORedeemableToken.json": 1103,
	"./docs/WyvernAtomicizer.json": 1104,
	"./docs/WyvernDAO.json": 1105,
	"./docs/WyvernDAOProxy.json": 1106,
	"./docs/WyvernExchange.json": 1107,
	"./docs/WyvernProxyRegistry.json": 1108,
	"./docs/WyvernToken.json": 1109,
	"./docs/WyvernTokenTransferProxy.json": 1110,
	"./docs/_template.jsx": 1111,
	"./index.md": 1112
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|jsx|js|markdown|md|ipynb|html|json|yaml|toml)$
// module id = 1079
// module chunks = 0